<template>
  <div>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-img 
            :alt="platformName"  
            contain 
            height="48px" 
            :src="require('@/assets/icons/unl.png')">
          </v-img>

          <h3 class="headline text-center pt-2">
            {{ platformName }}
          </h3>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-text>
      <label>Complete el siguiente formulario para registrarse en la plataforma:</label>
      <v-form>
        <v-text-field
          outline
          label="Nombre"
          type="text"
          v-model="name">
        </v-text-field>
        <v-text-field
          outline
          label="Apellido"
          type="text"
          v-model="lastname">
        </v-text-field>
        <v-text-field
          outline
          label="Correo electrónico"
          type="text"
          v-model="email">
        </v-text-field>
        <v-text-field
          outline
          hide-details
          label="Contraseña"
          type="password"
          :rules="passwordRules"
          v-model="password">
        </v-text-field>

        <v-checkbox v-model="terms_condition_accepted">
          <template v-slot:label>
            <div>
              Aceptar 
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a
                    @click="dialog=true"
                    v-on="on"
                  >
                    términos y condiciones
                  </a>
                </template>
                Vér terminos y condiciones
              </v-tooltip>
            </div>
          </template>
        </v-checkbox>
        
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    
    <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
      <v-row>
        <v-col cols="12">
          <v-btn 
            color="info" 
            :large="$vuetify.breakpoint.smAndUp" 
            :loading="loading"
            block
            :disabled="!terms_condition_accepted"
            @click="fieldsValidate">
            <v-icon left>lock</v-icon>
            Registrarse
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
   name: 'PostulateProject',
   props: {
      edition: String
   },
   data: () => ({
      dialog:false,
      error_dialog:false,
      loading:false,
      darkTheme: true,
      platformName:'JIJE UNL',
      name:'',
      lastname:'',
      email:'',
      password: '',
      terms_condition_accepted:false,
      emailRules: [ 
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v),
        v => this.validate(v)
      ],
      passwordRules: [ 
          v => !!v || "El campo es requerido",
          v => ( v && v >= 5 ) || "La contraseña debe tener al menos 5 caracteres",
          v => ( v && v <= 25 ) || "La contraseña no debe tener mas de 50 caracteres",
      ],
      error:'',
      errors:[],
      slug:null,
      convocation:[]
    }),
    computed: {
    ...mapGetters([
      'isLogged', 'user'
      ])
    },
    methods: {
      validate(a){
         if(a){
            return false
         }
         return true
      },

      fieldsValidate(){
        this.errors = []

        if(this.name.length==0){
          this.errors.push('- Por favor ingrese su nombre')
        }
        if(this.lastname.length==0){
          this.errors.push('- Por favor ingrese su apellido')
        }
        if(this.password.length<8){
          this.errors.push('- La contraseña debe tener al menos 8 caracteres')
        }
        if(!this.validateEmail(this.email)){
          this.errors.push('- El correo electrónico ingresado no es valido')
        }

        if(this.errors.length==0){
          this.register()
        }else{
          this.error_dialog = true
        }
      },

      validateEmail(email) {
        var re = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i 
        return re.test(email);
      },

      async getInfoEdition(){
        await axios.get('index/convocation/'+this.edition).then(response =>{
          if(!response.data.convocation){
            this.$router.push({ name: 'CheckConvocations' })   
            this.loading=false
          }else{
            this.convocation = response.data.convocation
            this.loading=false
          }
          
        }).catch(error => {
          console.log(error)
          if(error.response.status===404){
            this.$router.push({ name: 'UNLPotencia' })  
          }
        })
      },

      register () {
         this.loading=true
         this.$store
         .dispatch('register', {
            name:this.name,
            lastname: this.lastname,
            email: this.email,
            password: this.password,
            edition_id: this.convocation.id,
         })
         .then(() => {
            this.$router.push({ name: 'CheckConvocations' })   
            this.loading=false
         })
         .catch(() => {
            this.loading=false
            this.errors = []
            this.errors.push('Detectamos que en esta edición, tu correo electrónico ya se encuentra en uso')
            this.error_dialog = true
         })
      },

      cheakIsLogin(){
        if(this.isLogged){
          this.$router.push({ name: 'home' })
        }
      }
   },
   created(){
    this.getInfoEdition()
    this.cheakIsLogin()
   }
};
</script>